import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'course-ages';

export function index({
  is_only_name, order, page, size,
}) {
  return get({
    url,
    data: {
      is_only_name: is_only_name ? 1 : 0,
      order,
      page,
      size,
    },
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
